// extracted by mini-css-extract-plugin
export default {"add-checkbox-block":"addExistingDeviceDrawer_add-checkbox-block__goLlj","form-get-code-button":"addExistingDeviceDrawer_form-get-code-button__6Tw3M"};